import { ChangeDetectionStrategy, Component, input, linkedSignal, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import type { SelectedFileInterface } from '@sendpulse/file-manager';
import { DirectoryItemCategory, FmSourceType } from '@sendpulse/file-manager';

import type { BackgroundFile } from '@sites/entity-core';

import type { ReplacedFile } from '@components/sp-file-manager/src/types';
import { SpFileManagerComponent } from '@libs/components/sp-file-manager/src/sp-file-manager.component';
import { SpControlHandleComponent } from '@libs/ui/sp-control-handle/src/sp-control-handle.component';
import { SpSwitchComponent } from '@libs/ui/sp-switch/src/sp-switch.component';

@Component({
    selector: 'web-background-video-settings',
    templateUrl: './web-background-video-settings.component.html',
    styles: ':host { display: block; }',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TooltipModule, SpSwitchComponent, SpFileManagerComponent, SpControlHandleComponent, TranslateModule],
})
export class WebBackgroundVideoSettingsComponent {
    public readonly video = input<BackgroundFile | null>(null);
    public readonly disabled = input<boolean>(false);

    public readonly videoChange = output<BackgroundFile | null>();

    public readonly fmSourceType = FmSourceType;
    public readonly directoryItemCategory = DirectoryItemCategory;

    /** Reset by a new video or by disabling; in between, the switch opens it for a first pick. */
    public readonly showSettings = linkedSignal({
        source: () => ({ video: this.video(), isDisabled: this.disabled() }),
        computation: ({ video, isDisabled }) => !isDisabled && Boolean(video),
    });

    public toggleShowSettings(value: boolean): void {
        this.showSettings.set(value);

        if (!value) {
            this.videoChange.emit(null);
        }
    }

    public setVideo(file: SelectedFileInterface): void {
        this.videoChange.emit(file as BackgroundFile);
    }

    public replaceVideo({ file }: ReplacedFile): void {
        this.setVideo(file);
    }
}
